import { render, staticRenderFns } from "./ListOfGuests.vue?vue&type=template&id=47038060&scoped=true"
import script from "./ListOfGuests.vue?vue&type=script&lang=js"
export * from "./ListOfGuests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47038060",
  null
  
)

export default component.exports